import { render, staticRenderFns } from "./InviteMemberToOpenBonusBox.vue?vue&type=template&id=5997b132"
import script from "./InviteMemberToOpenBonusBox.vue?vue&type=script&lang=js"
export * from "./InviteMemberToOpenBonusBox.vue?vue&type=script&lang=js"
import style0 from "./InviteMemberToOpenBonusBox.vue?vue&type=style&index=0&id=5997b132&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports